import { render, staticRenderFns } from "./addChannelAccount.vue?vue&type=template&id=31a152f4&scoped=true&"
import script from "./addChannelAccount.vue?vue&type=script&lang=js&"
export * from "./addChannelAccount.vue?vue&type=script&lang=js&"
import style0 from "./addChannelAccount.vue?vue&type=style&index=0&id=31a152f4&lang=less&scoped=true&"
import style1 from "./addChannelAccount.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a152f4",
  null
  
)

export default component.exports